import { useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import FilterIcon from '../../../assets/svg/FilterIcon';
import { WidgetCard } from '../WidgetCard';

export const ChartDialActivities = ({ data }) => {
  const divRef = useRef(null);

  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!divRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });

    observer.observe(divRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  const { dials, reaches, pitches, bookings } = data;

  return (
    <WidgetCard title="Dial Activities" Icon={FilterIcon} className="pb-3">
      <div className="pt-3 pr-10 flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <div className="grid grid-cols-[56px_1fr] items-center gap-2">
            <span className="text-base-800 font-medium text-[12px]/[16px]">
              Dials
            </span>
            {dials !== 0 && (
              <div className="h-4 rounded-[4px] bg-brand-300/30 w-full" />
            )}
          </div>
          <span className="text-base-1000 font-semibold text-[18px]/[24px] pl-16">
            {dials}
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <div className="grid grid-cols-[56px_1fr] items-center gap-2">
            <span className="text-base-800 font-medium text-[12px]/[16px]">
              Reaches
            </span>
            <div
              className="h-4 rounded-[4px] bg-brand-300/50 relative"
              style={{ width: reaches.percentage }}
            >
              {reaches.count !== 0 && (
                <span className="w-8 absolute -right-10 text-base-1000 font-medium text-[12px]/[16px]">
                  {reaches.percentage}
                </span>
              )}
            </div>
          </div>
          <span className="text-base-1000 font-semibold text-[18px]/[24px] pl-16">
            {reaches.count}
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <div className="grid grid-cols-[56px_1fr] items-center gap-2">
            <span className="text-base-800 font-medium text-[12px]/[16px]">
              Pitches
            </span>
            <div style={{ width: reaches.percentage }}>
              <div
                className="h-4 relative flex gap-0.5"
                style={{ width: pitches.percentage }}
              >
                {pitches.attemptedPitches !== 0 && (
                  <div
                    ref={divRef}
                    className={twMerge(
                      'rounded-l-[4px] bg-brand-300 h-full',
                      pitches.completedPitches === 0 && 'rounded-[4px]',
                    )}
                    style={{ width: pitches.attemptedPitchesPercentage }}
                  />
                )}
                {pitches.completedPitches !== 0 && (
                  <div
                    className={twMerge(
                      'rounded-r-[4px] bg-brand-500 h-full',
                      pitches.attemptedPitches === 0 && 'rounded-[4px]',
                    )}
                    style={{ width: pitches.completedPitchesPercentage }}
                  />
                )}
                {pitches.count !== 0 && (
                  <span className="w-8 absolute -right-10 text-base-1000 font-medium text-[12px]/[16px]">
                    {pitches.percentage}
                  </span>
                )}
              </div>
            </div>
          </div>
          {pitches.count === 0 ? (
            <span className="text-base-1000 font-semibold text-[18px]/[24px] pl-16">
              {pitches.count}
            </span>
          ) : (
            <div className="flex gap-0.5 pl-16">
              {pitches.attemptedPitches !== 0 && (
                <div
                  className="flex flex-col gap-[1px] min-w-fit"
                  style={{ width }}
                >
                  <span className="text-base-800 font-medium text-[12px]/[16px]">
                    Attempted
                  </span>
                  <span className="text-base-1000 font-semibold text-[18px]/[24px]">
                    {pitches.attemptedPitches}
                  </span>
                </div>
              )}
              {pitches.completedPitches !== 0 && (
                <div className="flex flex-col gap-[1px]">
                  <span className="text-base-800 font-medium text-[12px]/[16px]">
                    Completed
                  </span>
                  <span className="text-base-1000 font-semibold text-[18px]/[24px]">
                    {pitches.completedPitches}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <div className="grid grid-cols-[56px_1fr] items-center gap-2">
            <span className="text-base-800 font-medium text-[12px]/[16px]">
              Bookings
            </span>
            <div
              className="h-4 rounded-[4px] bg-purple-500 relative"
              style={{ width: bookings.percentage }}
            >
              {bookings.count !== 0 && (
                <span className="w-8 absolute -right-10 text-base-1000 font-medium text-[12px]/[16px]">
                  {bookings.percentage}
                </span>
              )}
            </div>
          </div>
          <span className="text-base-1000 font-semibold text-[18px]/[24px] pl-16">
            {bookings.count}
          </span>
        </div>
      </div>
    </WidgetCard>
  );
};
